<div class="body">

    <div class="content" [formGroup]="formGroup">

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Code</mat-label>
            <input formControlName="code" matInput placeholder="Code aus E-Mail" />
        </mat-form-field>

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Passwort</mat-label>
            <input formControlName="password" matInput placeholder="Neues Passwort" type="password" />
        </mat-form-field>

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Passwort wiederholen</mat-label>
            <input formControlName="confirmPassword" matInput placeholder="Neues Passwort wiederholen" type="password" />
        </mat-form-field>

        <div class="footer">

            <button mat-raised-button color="primary" (click)="confirm()">
                Übermitteln
            </button>

        </div>

    </div>

</div>
